import { render } from "./RuleActivityReview.vue?vue&type=template&id=460e043a"
import script from "./RuleActivityReview.vue?vue&type=script&lang=js"
export * from "./RuleActivityReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleActivityReview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "460e043a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('460e043a', __exports__)) {
    api.reload('460e043a', __exports__)
  }
  
  module.hot.accept("./RuleActivityReview.vue?vue&type=template&id=460e043a", () => {
    api.rerender('460e043a', render)
  })

}


export default __exports__